import Vue from 'vue';
const files = require.context('@/layout', true, /\.vue$/i);
files.keys().map(key => Vue.component('layout-'+key.split('/').pop().split('.')[0], files(key).default))
